/**
 * Offline BTL: Discounted Price × per unit × per day (max number of days).
 *
 * BTL timeline is "Per Day", so DiscountedPrice is a per-day rate and the selected
 * number of days multiplies it directly (it is NOT divided by the seller's minimum).
 * "Per unit" = unitsToBebought. No timeslot.
 *
 *   Total = DiscountedPrice × units × days
 */
export function calculateOfflineBtlTotal(variant, selection) {
  const discountedPrice = Number(variant?.DiscountedPrice) || 0;
  const units = Number(selection?.unitsToBebought) || 1;
  const days = Number(selection?.timelineToBought) || 1;
  return discountedPrice * units * days;
}
